import { render, staticRenderFns } from "./WhiteListForm.vue?vue&type=template&id=25841450"
import script from "./WhiteListForm.vue?vue&type=script&lang=js"
export * from "./WhiteListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports